import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function CitationChip({ citation, onClick, documentName }) {
    const label = documentName
        ?? (citation.documentId ? citation.documentId.slice(0, 8) : 'doc');
    const meta = [];
    if (citation.chunkIndex !== undefined)
        meta.push(`chunk ${citation.chunkIndex}`);
    if (citation.pageNumber !== undefined)
        meta.push(`p.${citation.pageNumber}`);
    return (_jsxs("button", { type: "button", className: "citation-chip", onClick: onClick ? (() => onClick(citation)) : undefined, title: citation.score !== undefined ? `score ${citation.score.toFixed(3)}` : undefined, children: [_jsx("span", { className: "cite-doc", children: label }), meta.length > 0 && _jsx("span", { className: "cite-meta", children: meta.join(' \u00b7 ') })] }));
}
